/**
 * Age resilience score info text for a age bracket having less users
 */

export const AGE_RESILIENCE_INFO_TEXT =
  "There aren't enough employees in this age bracket to collect data for.";
